import React, { Component } from 'react';
import styled from 'styled-components';

import theme from '../../styles/theme';
import Message from './Message.styled';

const MessageStyle = styled(Message)`
  box-shadow: 0px 3px 4px rgba(247, 202, 40, 0.2);
  i {
    color: ${theme.colors.warning};
  }
`;

type Props = {
  text: string;
  title?: string;
};

export default class WarningMessage extends Component<Props> {
  render() {
    return (
      <MessageStyle>
        <div>
          <i className="material-icons">warning</i>
        </div>
        <div>
          <b>{this.props.title || 'Warning.'}</b>
          <p> {this.props.text}</p>
        </div>
      </MessageStyle>
    );
  }
}
